import * as zod from 'zod'

const rate = zod
  .number({ invalid_type_error: 'Must be a valid number' })
  .positive({ message: 'Must be greater than 0' })
  .max(10000, { message: 'Must be less than 10,000' })

export const createBillRateFlowSchema = zod.object({
  companyId: zod.number({ invalid_type_error: 'Company is required' }),
  positionId: zod.number({ invalid_type_error: 'Position is required' }),
  payRate: rate,
  billRate: rate,
})

export type CreateBillRateFlowSchema = zod.infer<
  typeof createBillRateFlowSchema
>
